export default {"src":"/sg/_next/static/media/jd-FloorLength.4611b302.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};